var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-border" },
    [
      _c("vidi-menu", {
        attrs: {
          "menu-list": _vm.menuHeadList,
          checkedMenu: _vm.checkedMenu,
          "first-menu-name": _vm.firstMenuName
        }
      }),
      _vm._v(" "),
      _vm.menuMiddleFlag
        ? _c(
            "div",
            { staticClass: "sale-channel" },
            [
              _c("el-divider"),
              _vm._v(" "),
              _c("p", [_vm._v("Sales Channel")]),
              _vm._v(" "),
              _c("vidi-menu", {
                attrs: {
                  "menu-list": _vm.menuMiddleList,
                  checkedMenu: _vm.checkedMenu,
                  "first-menu-name": _vm.firstMenuName
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "menu-bottom" },
        [
          _c("el-divider"),
          _vm._v(" "),
          _c("vidi-menu", {
            attrs: {
              "menu-list": _vm.menuFixtedList,
              checkedMenu: _vm.checkedMenu,
              "first-menu-name": _vm.firstMenuName
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77b07430", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b07430","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/left-menu.vue
// module id = 2tqM
// module chunks = 2